module.exports = __webpack_public_path__ + "static/media/restBackground.bc8b2d29.jpg";